import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Form, Input } from "antd";
import Add from "../../assets/Add";
import Edit from "../../assets/Edit";
import Delete from "../../assets/Delete";
import columns from "../../columns/pipeline/column";
import SkeletonTable from "../../components/table/SkeletonTable";
import LoadableButton from "../../components/button/LoadableButton";
import ModalComponent from "../../components/modals/ModalComponent";
import ConfirmationModal from "../../components/modals/ConfirmationModal";
import {
  CreatePipelineApi,
  DeletePipelineApi,
  getAllPipelineApi,
} from "../../api/request/pipeline";
import GlobalTooltip from "../../components/common/GlobalTooltip";

const Pipeline = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isCreateLoading, setIsCreateLoading] = useState(false);
  const [pipelineId, setPipelineId] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);

  const getPipelineList = async () => {
    try {
      setIsLoading(true);
      const { data } = await getAllPipelineApi();
      if (data.status) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              action: (
                <div className="flex items-center gap-3">
                  <GlobalTooltip title={"Edit Service Flow"}>
                    <button
                      onClick={() =>
                        navigate(`/service_flow/${item?.id}`, {
                          state: { pipeline: item },
                        })
                      }
                    >
                      <Edit />
                    </button>
                  </GlobalTooltip>
                  <GlobalTooltip title={"Delete Service Flow"}>
                    <button
                      onClick={() => {
                        setPipelineId(item?.id);
                        setIsDeleteModalOpen(true);
                      }}
                    >
                      <Delete />
                    </button>
                  </GlobalTooltip>
                </div>
              ),
            };
          })
        );
        setTotal(data?.total_record);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPipelineList();
  }, []);

  const createPipeline = async (value) => {
    try {
      setIsCreateLoading(true);
      const { data } = await CreatePipelineApi(value);
      if (data?.status) {
        toast.success(data?.message);
        setIsOpen(false);
        getPipelineList();
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsCreateLoading(false);
    }
  };

  const deletePipeline = async () => {
    try {
      setIsDeleteLoading(true);
      const { data } = await DeletePipelineApi({ id: pipelineId });
      if (data.status) {
        toast?.success(data?.message);
        setIsDeleteModalOpen(false);
        setPipelineId("");
        getPipelineList();
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsDeleteLoading(false);
    }
  };

  useEffect(() => {
    if (!isOpen) form.resetFields();
  }, [isOpen]);

  return (
    <>
      <div className="border rounded-lg bg-White pb-4">
        <div className="py-5 px-4 flex items-center justify-between">
          <h2 className="title">Services Flow {total ? `(${total})` : null}</h2>
          <button
            className="btn-primary !px-4 flex items-center gap-2"
            onClick={() => setIsOpen(true)}
          >
            <Add />
            <span>Add Service Flow</span>
          </button>
        </div>

        <SkeletonTable
          columns={columns}
          searchingFields={["name"]}
          data={data}
          isLoading={isLoading}
        />
      </div>

      <ModalComponent
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title="Create Service Flow"
      >
        <Form
          autoComplete="off"
          layout="vertical"
          form={form}
          className="w-full"
          onFinish={createPipeline}
        >
          <div className="input-white">
            <Form.Item
              name="name"
              label="Service Flow Name"
              className="mb-0"
              rules={[
                { required: true, message: "Please enter service flow name!" },
              ]}
            >
              <Input placeholder="Service Flow name" size="large" />
            </Form.Item>
          </div>

          <div className="text-center mt-5">
            <LoadableButton
              type="submit"
              lable="Submit"
              isLoading={isCreateLoading}
              loadingLable="Creating Flow..."
            />
          </div>
        </Form>
      </ModalComponent>

      {/* --- Delete confirmation modal --- */}
      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        setIsOpen={setIsDeleteModalOpen}
        message={`Are you sure you want to delete this service flow?`}
        onConfirm={deletePipeline}
        isLoading={isDeleteLoading}
        loadingLabel={`Deleting Flow...`}
      />
    </>
  );
};

export default Pipeline;
